export default __webpack_public_path__ + "static/background-2-2ac9b87f826571c5ab96bd87d67bef04.svg";